import React, { useEffect, useState } from "react";
import api from "../axiosSetup";
import { Card, Spinner, Toast, ToastContainer } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/Modal-Style.css"
import cfg from "../../config";

const ZREventTypes = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editType, setEditType] = useState(null);
  const [formData, setFormData] = useState({ name: "" });

  const [toast, setToast] = useState({ show: false, message: "", variant: "success" });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  useEffect(() => {
    loadEventTypes();
  }, []);

  const showToast = (message, variant = "success") => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast(prev => ({ ...prev, show: false })), 3000);
  };

  const loadEventTypes = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await api.get("/api/event-types", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTypes(res.data);
    } catch (err) {
      console.error("Fehler beim Laden:", err);
      showToast("Fehler beim Laden der Termin-Typen.", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (type = null) => {
    setEditType(type);
    setFormData({ name: type ? type.name : "" });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditType(null);
    setFormData({ name: "" });
    setShowModal(false);
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      showToast("Bitte einen Namen angeben.", "warning");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const config = { headers: { Authorization: `Bearer ${token}` } };

      if (editType) {
        if (parseInt(editType.id, 10) === 1) {
          showToast("Der Standard-Termin-Typ darf nicht bearbeitet werden.", "warning");
          return;
        }
        await api.put(`/api/event-types/${editType.id}`, formData, config);
        showToast("Termin-Typ erfolgreich bearbeitet!");
      } else {
        await api.post("/api/event-types", formData, config);
        showToast("Neuer Termin-Typ erfolgreich erstellt!");
      }

      handleCloseModal();
      loadEventTypes();
    } catch (err) {
      console.error("Fehler beim Speichern:", err);
      showToast("Fehler beim Speichern des Termin-Typs.", "danger");
    }
  };

  const confirmDelete = (id, name) => {
    if (parseInt(id, 10) === 1) {
      showToast("Der Standard-Termin-Typ darf nicht gelöscht werden.", "warning");
      return;
    }
    setDeleteId(id);
    setDeleteName(name);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await api.delete(`/api/event-types/${deleteId}`, config);
      showToast("Termin-Typ erfolgreich gelöscht!");
      setShowDeleteModal(false);
      loadEventTypes();
    } catch (err) {
      console.error("Fehler beim Löschen:", err);
      showToast("Fehler beim Löschen des Termin-Typs.", "danger");
    }
  };

  return (
    <div className="container py-4">
      <ToastContainer position="top-end" className="p-3">
        <Toast show={toast.show} bg={toast.variant} onClose={() => setToast({ ...toast, show: false })} delay={3000} autohide>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
        <h3 className="fw-bold text-primary mb-2">Termin-Typen verwalten</h3>
        <button className="btn btn-success rounded-pill shadow-sm" onClick={() => handleOpenModal()}>
          + Neuer Termin-Typ
        </button>
      </div>

      {loading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2 text-muted">Lade Termin-Typen...</p>
        </div>
      ) : types.length === 0 ? (
        <p className="text-center text-muted mt-4">Keine Termin-Typen vorhanden.</p>
      ) : (
        <div className="row g-3">
          {types.map((t) => (
            <div key={t.id} className="col-12 col-md-6 col-lg-4">
              <Card className="shadow-sm border-0 rounded-4 h-100">
                <Card.Body className="d-flex flex-column justify-content-between">
                  <Card.Title className="fw-semibold text-dark">{t.name}</Card.Title>
                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <button className="btn btn-outline-primary btn-sm" onClick={() => handleOpenModal(t)}>
                      ✏️ Bearbeiten
                    </button>
                    <button className="btn btn-outline-danger btn-sm" onClick={() => confirmDelete(t.id, t.name)}>
                      🗑️ Löschen
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      )}

      {/* === Modal: Erstellen/Bearbeiten === */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-box animate-in" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">
              {editType ? "Termin-Typ bearbeiten" : "Neuen Termin-Typ hinzufügen"}
            </h3>
            <div className="modal-section">
              <label className="fw-semibold">Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ name: e.target.value })}
                placeholder={`z. B. ${cfg.eventTerm}, Sitzung, Probe...`}
                className="form-control mt-2"
              />
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline-secondary" onClick={handleCloseModal}>
                Abbrechen
              </button>
              <button className="btn btn-primary" onClick={handleSave}>
                Speichern
              </button>
            </div>
          </div>
        </div>
      )}

      {/* === Modal: Löschen === */}
      {showDeleteModal && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-box animate-in" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title text-danger">Löschen bestätigen</h3>
            <div className="modal-section">
              Möchtest du den Termin-Typ <strong>{deleteName}</strong> wirklich löschen?
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline-secondary" onClick={() => setShowDeleteModal(false)}>
                Abbrechen
              </button>
              <button className="btn btn-danger" onClick={handleDelete}>
                Löschen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ZREventTypes;
